console.log('custom.js active');

// if (window.location.href.indexOf("/products/tranquilo-hoofdkussen") > -1) {
//   console.log('Kussen pagina');
  
//   const atcButtons = document.querySelectorAll('.btn-addtocart');
//   atcButtons.forEach(atcButton => {
//     atcButton.addEventListener('click', function(event) {  
    
//       event.preventDefault();
//       console.log('atc initiated');

//       atcButton.innerHTML = `Toevoegen...`;
    
//       const form = atcButton.closest('form');
    
//       const quantity = document.querySelector('.variant__item.active').getAttribute('data-quantity');
      
//       if (quantity == 1) {
//         form.submit();
//         return false;
//       }
      
//       const handle = 'tranquilo-kussen-deal';
//       fetch(`/products/${handle}.js`, {
//         method: 'GET',
//         credentials: 'same-origin',
//         headers: {
//           'Content-Type': 'application/json',
//           'X-Requested-With': 'xmlhttprequest' /* XMLHttpRequest is ok too, it's case insensitive */
//         }
//       }).then(function(response) {
//         return response.json();
//       }).then(function(product) {
//         const variant = product.variants[quantity - 1];
        
//         // document.querySelector('product-info [name="quantity"]').value = 1;
//         form.querySelector('.product-variant-id').value = variant.id;
//         form.submit();

//         atcButton.innerHTML = `In winkelwagen`;
    
//       }).catch(function(err) {
//         console.error(err)

//         atcButton.innerHTML = `In winkelwagen`;
//       });
    
//     })
//   });
// }

const variantSelectors = document.querySelectorAll('.variant__selector .variant__item');
if (variantSelectors) {
  variantSelectors.forEach(selector => {
    selector.addEventListener('click', function() {

      // const content = selector.getAttribute('data-content') ? selector.getAttribute('data-content') : null;
      // console.log(content);

      document.querySelector('.variant__selector .variant__item.active').classList.remove('active');
      
      selector.classList.add('active');

      const variantId = selector.getAttribute('data-variant-id');
      console.log(variantId);
      console.log(document.querySelector('.product__info-wrapper product-form.product-form [name="id"]'));
      document.querySelector('.product__info-wrapper product-form.product-form [name="id"]').value = variantId;
  
      // if (content) {
      //   console.log(content);
      //   document.querySelector('.pre-order-notification ul > li:last-child').innerHTML = content;
      // }

      const klarnaPrice = selector.getAttribute('data-klarna-price');

      if (!klarnaPrice) return false;

      document.querySelector('.klarna-message').innerHTML = `of 3 renteloze betalingen van €${klarnaPrice} met <svg class="icon icon--full-color" xmlns="http://www.w3.org/2000/svg" role="img" width="38" height="24" viewBox="0 0 38 24" aria-labelledby="pi-klarna"><title id="pi-klarna">Klarna</title><g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd"><path d="M35 0H3C1.3 0 0 1.3 0 3v18c0 1.7 1.4 3 3 3h32c1.7 0 3-1.3 3-3V3c0-1.7-1.4-3-3-3z" fill="#FFB3C7"></path><path d="M35 1c1.1 0 2 .9 2 2v18c0 1.1-.9 2-2 2H3c-1.1 0-2-.9-2-2V3c0-1.1.9-2 2-2h32" fill="#FFB3C7"></path><path d="M34.117 13.184c-.487 0-.882.4-.882.892 0 .493.395.893.882.893.488 0 .883-.4.883-.893a.888.888 0 00-.883-.892zm-2.903-.69c0-.676-.57-1.223-1.274-1.223-.704 0-1.274.547-1.274 1.222 0 .675.57 1.223 1.274 1.223.704 0 1.274-.548 1.274-1.223zm.005-2.376h1.406v4.75h-1.406v-.303a2.446 2.446 0 01-1.394.435c-1.369 0-2.478-1.122-2.478-2.507 0-1.384 1.11-2.506 2.478-2.506.517 0 .996.16 1.394.435v-.304zm-11.253.619v-.619h-1.44v4.75h1.443v-2.217c0-.749.802-1.15 1.359-1.15h.016v-1.382c-.57 0-1.096.247-1.378.618zm-3.586 1.756c0-.675-.57-1.222-1.274-1.222-.703 0-1.274.547-1.274 1.222 0 .675.57 1.223 1.274 1.223.704 0 1.274-.548 1.274-1.223zm.005-2.375h1.406v4.75h-1.406v-.303A2.446 2.446 0 0114.99 15c-1.368 0-2.478-1.122-2.478-2.507 0-1.384 1.11-2.506 2.478-2.506.517 0 .997.16 1.394.435v-.304zm8.463-.128c-.561 0-1.093.177-1.448.663v-.535H22v4.75h1.417v-2.496c0-.722.479-1.076 1.055-1.076.618 0 .973.374.973 1.066v2.507h1.405v-3.021c0-1.106-.87-1.858-2.002-1.858zM10.465 14.87h1.472V8h-1.472v6.868zM4 14.87h1.558V8H4v6.87zM9.45 8a5.497 5.497 0 01-1.593 3.9l2.154 2.97H8.086l-2.341-3.228.604-.458A3.96 3.96 0 007.926 8H9.45z" fill="#0A0B09" fill-rule="nonzero"></path></g></svg>`;


      // const oldPrice = document.querySelectorAll('.pricing .old-price');
      // const newPrice = document.querySelectorAll('.pricing .new-price');
      // const pdpLabel = document.querySelectorAll('.pdp-label span');

      // if (!oldPrice) return false;

      // oldPrice.forEach(p => {
      //   p.innerHTML = document.querySelector('.variant__selector .variant__item.active .variant__price .old-price').innerHTML;
      // })
      // newPrice.forEach(p => {
      //   p.innerHTML = document.querySelector('.variant__selector .variant__item.active .variant__price .new-price').innerHTML;
      // })
      // pdpLabel.forEach(p => {
      //   p.innerHTML = document.querySelector('.variant__selector .variant__item.active .variant__label').innerHTML;
      // })
    })
  })
}

const changingSelectors = document.querySelectorAll('.variant__selector .variant__item');
if (changingSelectors) {
  changingSelectors.forEach(selector => {
    selector.addEventListener('click', function() {
      const oldPrice = document.querySelectorAll('.pricing .old-price');
      const newPrice = document.querySelectorAll('.pricing .new-price');
      const pdpLabel = document.querySelectorAll('.pdp-label span');
      const amount = selector.getAttribute('data-amount');

      if (!oldPrice) return false;

      oldPrice.forEach(p => {
        p.innerHTML = document.querySelector('.variant__selector .variant__item.active .variant__price .old-price').innerHTML;
      })
      newPrice.forEach(p => {
        p.innerHTML = document.querySelector('.variant__selector .variant__item.active .variant__price .new-price').innerHTML;
      })
      pdpLabel.forEach(p => {
        p.innerHTML = document.querySelector('.variant__selector .variant__item.active .variant__label').innerHTML;
      })

      console.log(document.querySelector('.sticky__atc .pricing > span'));

      document.querySelectorAll('.sticky__atc h5').forEach(e => {
        e.innerHTML = `${amount} hoofdkussen${amount > 1 ? 's' : ''}`;
      })
      document.querySelectorAll('.sticky__atc .pricing > span').forEach(e => {
        e.innerHTML = document.querySelector('.variant__selector .variant__item.active .variant__price .new-price').innerHTML;
      })
      document.querySelectorAll('.sticky__atc .pricing > small').forEach(e => {
        e.innerHTML = document.querySelector('.variant__selector .variant__item.active .variant__price .old-price').innerHTML;
      })
      document.querySelectorAll('.sticky__atc .product-variant-id').forEach(e => {
        e.value = document.querySelector('.variant__selector .variant__item.active').getAttribute('data-variant-id');
      })
    })
  })
}





window.addEventListener('load', function() {
  if (document.querySelector('.variant__item.active')) {
    document.querySelector('.variant__item.active').click();
  }
})

const tabLinks = document.querySelectorAll('.nav-tabs .nav-link');
if (tabLinks) {
  tabLinks.forEach(link => {
    link.addEventListener('click', function(event) {
      event.preventDefault();

      document.querySelector('.nav-tabs .nav-link.active').classList.remove('active');
      
      link.classList.add('active');

      const tabs = document.querySelectorAll('.texttabssection .tab-design.tab-pane');
      tabs.forEach(tab => {
        if (tab.id == link.getAttribute('href').replace('#', '')) {
          document.querySelector('.texttabssection .tab-design.tab-pane.active').classList.remove('active');
          tab.classList.add('active');
        }
      })

    })
  })
}

const navItems = document.querySelectorAll('.header__inline-menu .list-menu__item');
if (navItems) {
  navItems.forEach(item => {
    item.addEventListener('click', function(event) {
      if (item.querySelector('span').innerHTML == 'Shop') {
        event.preventDefault();

        const subnav = document.querySelector('.subnav');
        if (subnav.classList.contains('shown')) {
          hideSubnav();
        } else {
          showSubnav();
        }
      }
    })
  })
}

const navToggleMobile = document.querySelector('.header__icon--menu');
if (navToggleMobile) {
  navToggleMobile.addEventListener('click', function(event) {
    event.preventDefault();

      const subnav = document.querySelector('.subnav');
      if (subnav.classList.contains('shown')) {
        hideSubnav();
      } else {
        showSubnav();
      }
  })
}

function showSubnav() {
  console.log('Show subnav');

  const subnav = document.querySelector('.subnav');
  subnav.classList.add('shown');
}

function hideSubnav() {
  const subnav = document.querySelector('.subnav');
  subnav.classList.remove('shown');
}

window.addEventListener('scroll', function() {

  const subnav = document.querySelector('.subnav');
  if (subnav.classList.contains('shown')) {
    hideSubnav();
  }
})

const dealButtons = document.querySelectorAll('[href="#deal"],[href="#clearpuredeal"]');
dealButtons.forEach(button => {
  button.addEventListener('click', function(event) {

    const deal = document.querySelector('#deal');

    if (!deal) {
      event.preventDefault();
      window.location.href = '/products/tranquilo-hoofdkussen';
    }
  })
})

window.addEventListener('scroll', function() {
  if (!window.pageYOffset) {
    document.querySelector('.header-outer').classList.remove('scrolled');
  } else {
    document.querySelector('.header-outer').classList.add('scrolled');
  }
})

window.addEventListener('load', function() {
  
  const url = new URL(window.location.href);
  if (url.searchParams.has('drawer')) {
    document.querySelector('.header__icon--cart').click();
  }
})

// If Rebuy cart is shown
// document.addEventListener('rebuy:smartcart.show', function(event) { 
//   console.log('Rebuy shown.');

//   let upsellProducts = document.querySelectorAll('.rebuy-cart__flyout-recommendations .rebuy-product-grid .rebuy-product-block');
//   checkUpsellProduct(upsellProducts);

//   setTimeout(function(){
//     upsellProducts = document.querySelectorAll('.rebuy-cart__flyout-recommendations .rebuy-product-grid .rebuy-product-block');
//     checkUpsellProduct(upsellProducts);
//   }, 500);
// });

// document.addEventListener('rebuy.ready', function(event){
//   console.log('Rebuy ready.');

//   let upsellProducts = document.querySelectorAll('.rebuy-cart__flyout-recommendations .rebuy-product-grid .rebuy-product-block');
//   checkUpsellProduct(upsellProducts);

//   setTimeout(function(){
//     upsellProducts = document.querySelectorAll('.rebuy-cart__flyout-recommendations .rebuy-product-grid .rebuy-product-block');
//     checkUpsellProduct(upsellProducts);
//   }, 500);
// });

// function checkUpsellProduct(upsellProducts) {
//   console.log('Checking upsell products...');
//   const upsellHeading = document.querySelector('.rebuy-cart__flyout-recommendations .rebuy-widget-container .primary-title');

//   upsellProducts.forEach(product => {

//     // If 49.99 pillow
//     if (product.classList.contains('product-id-8352851689799')) {
//       upsellHeading.innerHTML = `Koop een 2e kussen met 50% korting!`;
//     }

//     // If 39.99 pillow
//     if (product.classList.contains('product-id-8352852345159')) {
//       upsellHeading.innerHTML = `Koop een 3e kussen met 60% korting!`;
//     }

//     // If 34.99 pillow
//     if (product.classList.contains('product-id-8390623199559')) {
//       upsellHeading.innerHTML = `Koop een 4e kussen met 65% korting!`;
//     }
//   })
// }

/* Sort reviews on page load */
window.addEventListener('load', function() {
  document.querySelector('[id="oke-sortSelect--reviews"]').value = 'date desc';
  var event = new Event('change');

  document.querySelector('[id="oke-sortSelect--reviews"]').dispatchEvent(event); 

  setTimeout(() => {
    document.querySelector('[id="oke-sortSelect--reviews"]').dispatchEvent(event); 
  }, 1000);

  setTimeout(() => {
    document.querySelector('[id="oke-sortSelect--reviews"]').dispatchEvent(event); 
  }, 2000);

  setTimeout(() => {
    document.querySelector('[id="oke-sortSelect--reviews"]').dispatchEvent(event); 
  }, 3000);
})



window.addEventListener('scroll', function() {
  const promoBars = document.querySelectorAll('.promo-bar');

  let top = this.scrollY;
  if (top > 50) {
    promoBars.forEach(e => {
      e.classList.add('sticky');
    })
  } else {
    promoBars.forEach(e => {
      e.classList.remove('sticky');
    })
  }

})